import Bind from 'bind.js';
import notification from 'notification-js';
import Config from 'config';
import stringToDom from 'string-to-dom';
import merge from 'deepmerge';
import Register from '../Register';
import AuthDataStorage from "./../AuthDataStorage";

export default class BuyAddons {
  constructor({parentElement, data}) {
    this.authDataStorage = new AuthDataStorage();
    this.editor = false;
    this.mainPackageId = null;
    this.mainPackage = null;
    this.pricesCache = {};

    let queryStrings = window.location.search.substr(1).split("&");

    queryStrings.forEach((queryString) => {
      if (queryString.indexOf("editor=") === 0) {
        this.editor = queryString.substr(7) == "true";
      }
      if (queryString.indexOf("id=") === 0) {
        this.mainPackageId = parseInt(queryString.substr(3));
      }
    });

    this.parentElement = parentElement;
    this.data = data;
    this.getPackageInfo();
    this.addPriceBoxTemplate();
    this.addPrices();
  }

  addPriceBoxTemplate() {
    let template = `<div class="addons-container">
        <div class="buy-addons-items"></div>
        <div class="package-summary">
            <div class="package-price-container">Package price &pound;<span class="package-price">0</span> per mouth</div>
            <div class="addons-price-container">Addons price &pound;<span class="addons-price">0</span> per mouth</div>
            <div>Total price &pound;<span class="total-price">0</span> per mouth</div>
        </div>
        <div class="addon-clear"></div>
        <button class="register-button">Next</button>
      </div>`;


    this.parentElement.insertAdjacentHTML("afterbegin", template);

    if (this.mainPackageId !== null) {
      document.getElementsByClassName("register-button")[0].onclick = function (event) {
        localStorage.setItem(this.mainPackageId + "-addons", JSON.stringify(this.pricesCache));
        window.location.href = "/register.html?id=" + this.mainPackageId;
      }.bind(this);
    } else {
      // if user wants buy addons from account page
      var loggedIn = this.authDataStorage.getLoggedIn();
      if (!loggedIn && !this.editor) {
        window.location.href = "/buy-now.html";
      }
      document.getElementsByClassName("package-price-container")[0].style.display = "none";
      document.getElementsByClassName("addons-price-container")[0].style.display = "none";

      document.getElementsByClassName("register-button")[0].onclick = function (event) {
        let licenseIds = Object.keys(this.pricesCache);
        if (licenseIds.length === 0) {
          notification.notify( 'error', "Please select addons to buy", {
            notification: {position: [ 'right', 'top' ]}
          });
          return;
        }
        let ids = licenseIds.join(',');
        localStorage.setItem(ids + "-addons", JSON.stringify(this.pricesCache));
        window.location.href = "/payment.html?id=" + ids;
      }.bind(this);
    }
  }

  getOptionLabel(key) {
    switch(key) {
      case 'user': return 'Users';
      case 'project': return 'Projects';
      case 'teams': return 'Teams';
      case 'displays': return 'Displays';
      case 'library': return 'GB';
      default : return;
    }
  }

  getOptionKey(key) {
    switch(key) {
      case 'user': return 'numberOfUsers';
      case 'project': return 'numberOfProjects';
      case 'teams': return 'numberOfTeams';
      case 'displays': return 'numberOfDisplays';
      case 'library': return 'storage';
      default : return;
    }
  }

  addPrices() {
    let prices = this.data.get('prices').toJS();

    prices.forEach((price) => {
      price.selectedOption = 0;
    });

    this.buynow = Bind(
      {prices: prices},
      {
        prices: function(prices) {
          if (this.xobj && this.xobj.length > 0) {
            for (var i = 0; i < this.xobj.length; i++) {
              this.xobj[i].abort();
            }
          }

          this.xobj = [];
          var buyNowContainer = this.parentElement.getElementsByClassName('buy-addons-items')[0];

          buyNowContainer.innerHTML = "";

          for (let i = 0; i < prices.length; i ++) {
            let price = prices[i];

            let displayOptions = document.createElement("div");

            let selectDisplay = "none";

            let amountTerm = price.amountTerm ? price.amountTerm : 'month';

            let elementTemplate = `<div class="addon-item">
              <div class="">
                <div class="title">${price.name}</div>
                <div class="total-of-item">&pound;<span>0</span></div>                
                <div class="qty"><a class="down" href="#">-</a><input readonly="readonly" type="text" value="0"><a class="up" href="#">+</a></div>
                <div class="frequency">&pound;${price.amount} per ${amountTerm}</div>  
                <div class="addon-clear"></div>
              </div>
            </div>`;

            let priceEl = stringToDom(elementTemplate);
            buyNowContainer.appendChild(priceEl);

            priceEl.getElementsByClassName("down")[0].onclick = function (event) {
              this.updateAddonCount(priceEl, -1, price);
              return false;
            }.bind(this);

            priceEl.getElementsByClassName("up")[0].onclick = function (event) {
              this.updateAddonCount(priceEl, 1, price);
              return false;
            }.bind(this);

            this.xobj[i] = new XMLHttpRequest();
            this.xobj[i].overrideMimeType("application/json");
            this.xobj[i].index = i;
            this.xobj[i].open("GET", Config.BACKEND_URL + '/retrieveLicence/' + price.licenceId);
            this.xobj[i].onreadystatechange = function () {
              if (this.xobj[i].readyState == 4) {
                if (this.xobj[i].status == "200") {
                  let licence = JSON.parse(this.xobj[i].response);


                }
              }
            }.bind(this);
            this.xobj[i].setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            this.xobj[i].send();
          }
        }.bind(this)
      }
    );
  }

  updateAddonCount(priceRowElement, updateValue, price) {
    let inputElement = priceRowElement.getElementsByTagName("input")[0];
    let count = parseInt(inputElement.value);
    if (count + updateValue < 0) {
      return;
    }
    inputElement.value = count + updateValue;
    this.pricesCache[price.licenceId] = {
      name: price.name,
      count: parseInt(inputElement.value),
      price: price.amount,
      amount: price.amount*parseInt(inputElement.value),
      monthAmount: price.amountTerm == "year" ? parseFloat(((price.amount/12)*parseInt(inputElement.value)).toFixed(2)) : price.amount*parseInt(inputElement.value)
    };
    priceRowElement.getElementsByClassName("total-of-item")[0].getElementsByTagName("span")[0].innerHTML = this.pricesCache[price.licenceId].amount;
    if (this.pricesCache[price.licenceId].count == 0) {
      delete this.pricesCache[price.licenceId];
    }
    this.updatePrices();
  }

  updatePrices() {
    let priceOfPackageElement = document.getElementsByClassName("package-price")[0];
    let priceOfAddonsElement = document.getElementsByClassName("addons-price")[0];
    let totalPriceElement = document.getElementsByClassName("total-price")[0];
    let addonsAmount = 0;
    if (this.mainPackage !== null) {
      priceOfPackageElement.innerHTML = this.mainPackage.amount;
    }
    for (let licenceId in this.pricesCache) {
      if (this.pricesCache.hasOwnProperty(licenceId)) {
        addonsAmount += this.pricesCache[licenceId].monthAmount;
      }
    }
    priceOfAddonsElement.innerHTML = addonsAmount;
    if (this.mainPackage) {
      addonsAmount += parseInt(this.mainPackage.amount);
    }

    totalPriceElement.innerHTML = addonsAmount;

  }

  getPackageInfo() {
    if (!this.mainPackageId) {
      return;
    }
    let data = {
      file: './data/buy-now.json'
    };
    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let licenceInfo = JSON.parse(xobj.response);
        let licences = licenceInfo.sections[0].prices; // get licence for marketing name

        for (var i =0; i< licences.length; i++) {
          if (parseInt(licences[i].licenceId) == this.mainPackageId) {
            this.mainPackage = licences[i];
            break;
          }
        }
        if (this.mainPackage === null) {
          window.location.href = "/buy-now.html";
        }
        this.updatePrices();
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xobj.send(JSON.stringify(data));
  }


  reRender(data) {
    this.data = data;

    this.buynow.prices = data.get('prices').toJS();
  }
}



// WEBPACK FOOTER //
// ./src/renderers/BuyAddons.js